import { render, staticRenderFns } from "./DocInput.vue?vue&type=template&id=36db6eb1&scoped=true&"
import script from "./DocInput.vue?vue&type=script&lang=js&"
export * from "./DocInput.vue?vue&type=script&lang=js&"
import style0 from "./DocInput.vue?vue&type=style&index=0&id=36db6eb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36db6eb1",
  null
  
)

export default component.exports